import React from 'react'

import './Electronics.css'
import Product from './Product';

function Electronics() {
    return (
        <div >
            <h1 className="elehead">Electronics & accessories</h1>
            <img className="eleimg" src="https://images-eu.ssl-images-amazon.com/images/G/31/img21/Audio/bankOffer/1/LP_Stripe_PC.jpg"/>
          <img className="eleimg" src="https://images-eu.ssl-images-amazon.com/images/G/31/img21/Audio/bankOffer/OneCard-Desktop.jpg"/>
          
          <div className="home_row">

<Product title='boAt Airdopes 121v2 TWS Earbuds with Bluetooth V5.0, Immer...' price={1299}  image='https://m.media-amazon.com/images/I/71ByNT34bfL._SL1500_.jpg' rating={4} />
<Product title="boAt Xtend Smartwatch with Alexa Built-in, 1.69” HD Display..."price={3499}  image='https://m.media-amazon.com/images/I/61IMRs+o0iL._SL1500_.jpg' rating={4} />
<Product title="iQOO Z3 5G (Ace Black, 6GB RAM, 128GB Storage) "price={12999}  image='https://m.media-amazon.com/images/I/61uIgwiP90S._SL1200_.jpg' rating={4} />
<Product title="Modernista Maestro Bar 20W Bluetooth Soundbar Speaker with 2400mah Battery"price={1504}  image='https://m.media-amazon.com/images/I/71JfjXWijxL._SL1500_.jpg' rating={3} />
</div>
<img className="eleimg" src="https://images-eu.ssl-images-amazon.com/images/G/31/img21/Audio/bankOffer/1/HSBC_EMI-fest_stripe_1500x120.jpg"/>

<div className="home_row">

                 <Product title='Xiaomi 11 Lite NE 5G (Jazz Blue 6GB RAM 128 GB Storage) ' price={26999}  image='https://m.media-amazon.com/images/I/71XmlboxNZL._SL1500_.jpg' rating={4} />
                 <Product title="OnePlus Nord CE 5G (Blue Void, 8GB RAM, 128GB Storage)"price={24999}  image='https://m.media-amazon.com/images/I/61iy2Ru9KdS._SL1500_.jpg' rating={4} />
                 <Product title="iQOO Z3 5G (Ace Black, 6GB RAM, 128GB Storage) "price={12999}  image='https://m.media-amazon.com/images/I/61uIgwiP90S._SL1200_.jpg' rating={4} />
                 <Product title="Redmi 9 Activ (Coral Green, 4GB RAM, 64GB Storage)"price={8499}  image='https://m.media-amazon.com/images/I/91kAtEXPIeL._SL1500_.jpg' rating={3} />
             </div>
             <div className="home_row">
                 <Product title='Samsung Galaxy S20 FE 5G (Cloud Navy, 8GB RAM, 128GB Storage) ' price={36990}  image='https://m.media-amazon.com/images/I/81vDZyJQ-4L._SL1500_.jpg' rating={4} />
                 <Product title="Samsung Galaxy M32 5G (Sky Blue, 6GB RAM, 128GB Storage)"price={16999}  image='https://m.media-amazon.com/images/I/71os5DRhuSL._SL1500_.jpg' rating={4} />
                 <Product title="Samsung Galaxy M21 2021 Edition (Charcoal black, 6GB RAM, 128GB Storage) "price={13999}  image='https://m.media-amazon.com/images/I/712+A5mH44L._SL1500_.jpg' rating={4} />
                 <Product title="Samsung Galaxy Note 20 Ultra 5G (Mystic Bronze, 12GB RAM, 256GB Storage)"price={84999}  image='https://m.media-amazon.com/images/I/71eVZFpYUvL._SL1500_.jpg' rating={5} />
             </div>
        </div>
    )
}

export default Electronics
